import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { unwrap } from '../utils/api';
import Icon from '../components/Icon';

export default function CreateProduct() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', price: 18.99, tags: 'Hebrew', categoriesIds: [], published: false, wooProductId: 0, productOrderIndex: 0 });
  const [file, setFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/categories/GetCategoriesAndSubCategoriesSimple').then(r => setCategories(unwrap(r) || []));
  }, []);

  function update(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function save() {
    setBusy(true);
    try {
      let filesId = null;
      if (file) {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('type', 'background');
        const r = await api.post('/files/SaveImage', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        filesId = unwrap(r)._id;
      }
      const payload = {
        ...form,
        tags: form.tags.split(',').map(s => s.trim()).filter(Boolean),
        filesId,
      };
      const r = await api.post('/products/CreateProduct', payload);
      navigate(`/pages/editProductFields/${unwrap(r)._id}`);
    } finally { setBusy(false); }
  }

  return (
    <>
      <h1>Create Product</h1>
      <div className="card" style={{ maxWidth: 720 }}>
        <div className="prop"><label>Name</label><input value={form.name} onChange={e => update('name', e.target.value)} /></div>
        <div className="prop"><label>Price (USD)</label><input type="number" step="0.01" value={form.price} onChange={e => update('price', Number(e.target.value))} /></div>
        <div className="prop"><label>Categories</label>
          <select multiple value={form.categoriesIds} onChange={e => update('categoriesIds', Array.from(e.target.selectedOptions, o => o.value))} style={{ height: 120 }}>
            {categories.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
          </select>
        </div>
        <div className="prop"><label>Tags (comma-separated)</label><input value={form.tags} onChange={e => update('tags', e.target.value)} placeholder="Lushen Kodesh, Colored, Vertical (8.5x11)" /></div>
        <div className="prop"><label>Background image (JPG/PNG)</label><input type="file" accept="image/*" onChange={e => setFile(e.target.files[0])} /></div>
        <div className="prop"><label><input type="checkbox" checked={form.published} onChange={e => update('published', e.target.checked)} /> Published</label></div>
        <button className="btn" onClick={save} disabled={busy || !form.name}>{busy ? 'Saving…' : <>Save &amp; Lay out fields <Icon name="arrow_forward" /></>}</button>
      </div>
    </>
  );
}
